module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-controller"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-card',
      "item": _vm.item.main_driver
    }
  })], 1), _c('div', {
    staticClass: "columns small-12 large-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column m-1"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "field-value"
  }, [_vm._v(_vm._s(_vm.item.status))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.checkLoader) ? _c('loading-spinner') : _vm._e(), (_vm.checkedData && _vm.showCheck) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "row columnizer",
    domProps: {
      "innerHTML": _vm._s(_vm.showObject(null, _vm.checkedData))
    }
  })]) : _vm._e(), (!_vm.showCheck) ? _c('div', {
    staticClass: "button small m-1 float-left",
    on: {
      "click": function($event) {
        return _vm.loadCheckedData('quick')
      }
    }
  }, [_vm._v("Quick Check")]) : _vm._e(), (!_vm.showCheck) ? _c('div', {
    staticClass: "button small m-1 float-right",
    on: {
      "click": function($event) {
        return _vm.loadCheckedData('complete')
      }
    }
  }, [_vm._v("Complete Check")]) : _c('div', {
    staticClass: "button small m-1 float-right",
    on: {
      "click": _vm.showHideCheckButton
    }
  }, [_vm._v("Hide Data")])], 1)])])])]), _c('div', {
    staticClass: "container"
  }, [(_vm.$acl('balance-billing')) ? _c('div', {
    staticClass: "balance"
  }, [(_vm.balanceLoader) ? _c('loading-spinner') : _c('Cards', {
    attrs: {
      "data": _vm.clientMetrics
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6"
  }, [_c('client', {
    attrs: {
      "type": 'highlightedNotes',
      "item": _vm.item
    }
  })], 1)]), _c('div', {
    staticClass: "row column"
  }, [_c('router-tab-headers', {
    attrs: {
      "id": "client-details",
      "tabs": _vm.tabs,
      "id": 'client-detail',
      "activeIndex": 0,
      "deepLink": true
    }
  }, [_c('router-view')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b9bb7d0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/Client.vue
// module id = 2569
// module chunks = 1